<template>
    <div class="modal_cont gsrst01010101_view">
        <div v-if="!inlineMode" class="modal_header">
            {{ activeGuide.tab }}
            <a href="#none" @click="closeModal" class="btn_close">닫기</a>
        </div>

        <div class="modal_content">
            <p class="type_info_bar" v-html="activeGuide.infoBar"></p>
            <div class="type_table_wrap">
                <table class="type_table">
                    <colgroup>
                        <col class="col_item_main" />
                        <col class="col_item_main" />
                        <col class="col_item_sub" />
                        <col class="col_cost" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="3" scope="col">{{ activeTableHead.item }}</th>
                            <th scope="col">{{ activeTableHead.cost }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in activeGuide.tableRows" :key="index" :class="{ is_gray: row.isGray }">
                            <th v-if="row.main" :rowspan="row.mainRowspan" scope="rowgroup">{{ row.main }}</th>
                            <th v-if="row.subMain" :rowspan="row.subMainRowspan" scope="rowgroup">{{ row.subMain }}</th>
                            <th :colspan="row.subColspan || 1" :scope="row.scope || 'row'" v-html="row.sub"></th>
                            <td v-html="row.cost"></td>
                        </tr>
                    </tbody>
                </table>
                <ul v-if="activeGuide.cautions && activeGuide.cautions.length" class="list_caution">
                    <li v-for="(caution, index) in activeGuide.cautions" :key="index">
                        <p v-html="caution.text"></p>
                    </li>
                </ul>
            </div>
            <div v-if="activeGuide.graph" class="type_graph_wrap">
                <strong>{{ activeGuide.graph.title }}</strong>
                <ul class="type_graph_inner">
                    <li v-for="(graphItem, graphIndex) in activeGuide.graph.items" :key="graphIndex" class="type_graph_item">
                        <p v-html="graphItem.label"></p>
                        <picture>
                            <source media="(max-width: 768px)" :srcset="graphItem.imgMo" />
                            <img :src="graphItem.img" :alt="graphItem.alt" />
                        </picture>
                    </li>
                </ul>
            </div>
            <div v-if="activeGuide.warning" class="warning_box">
                <p>{{ activeGuide.warning }}</p>
            </div>
        </div>

        <div class="modal_bottom">
            <Buttons btn-class="btn_big primary" @click="closeModal">확인</Buttons>
            <Buttons btn-class="btn_big gary" @click="printModal">{{ inlineMode ? "닫기" : "인쇄하기" }}</Buttons>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import modal from "@/utils/popupModal";
import Buttons from "@/components/Buttons.vue";

const props = defineProps({
    guide: {
        type: Object,
        default: null,
    },
    tableHead: {
        type: Object,
        default: () => ({
            item: "항목",
            cost: "비용",
        }),
    },
    inlineMode: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(["close"]);

const fallbackGuide = {
    tab: "가맹 조건 안내",
    infoBar: "",
    tableRows: [],
    cautions: [],
    warning: "",
};

const activeGuide = computed(() => ({
    ...fallbackGuide,
    ...(props.guide || {}),
    tableRows: props.guide?.tableRows || [],
    cautions: props.guide?.cautions || [],
}));

const activeTableHead = computed(() => ({
    item: props.tableHead?.item || "항목",
    cost: props.tableHead?.cost || "비용",
}));

function closeModal(event) {
    if (props.inlineMode) {
        emit("close");
        return;
    }

    if (event?.currentTarget) {
        modal.close(event.currentTarget);
    }
}

function printModal(event) {
    if (props.inlineMode) {
        closeModal(event);
        return;
    }

    window.print();
}
</script>

<style scoped>
:deep(.m_br) { display: none; }
:deep(.p_br) { display: block; }
.type_info_bar { margin: 0; padding: 18px 24px; color: #161616; font-size: 2rem; font-weight: 600; line-height: 1.35; letter-spacing: -0.01em; background-color: #f1faf6; border-radius: 8px; word-break: keep-all; }
.type_table_wrap { margin-top: 20px; overflow-x: auto; border-top: 1px solid #161616; }
.type_table { width: 100%; min-width: 720px; border-collapse: collapse; }
.type_table .col_item_main { width: 130px; }
.type_table .col_item_sub { width: 210px; }
.type_table .col_cost { width: auto; }
.type_table thead th { padding: 24px; color: #161616; font-size: 1.8rem; font-weight: 600; line-height: 1.4; letter-spacing: -0.01em; background-color: #f8f8f8; border: 1px solid #e5e5e9; text-align: center; }
.type_table tbody th { padding: 12px 24px; color: #161616; font-size: 1.8rem; font-weight: 400; line-height: 1.4; letter-spacing: -0.01em; background-color: #f8f8f8; border: 1px solid #e5e5e9; text-align: left; word-break: keep-all; }
.type_table tbody td { padding: 12px 24px; color: #161616; font-size: 1.8rem; font-weight: 400; line-height: 1.4; letter-spacing: -0.01em; border: 1px solid #e5e5e9; text-align: center; word-break: keep-all; }
.type_table tbody tr.is_gray th,
.type_table tbody tr.is_gray td { background-color: #f8f8f8; }
.list_caution { margin-top: 16px; }
.list_caution li + li { margin-top: 6px; }
.list_caution p { color: #67676f; font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; word-break: keep-all; }
.type_graph_wrap { margin-top: 40px; padding: 40px; background-color: #f8f8f8; border-radius: 8px; }
.type_graph_wrap > strong { display: block; font-size: 2.4rem; font-weight: 700; line-height: 1.35; letter-spacing: -0.01em; }
.type_graph_inner { margin-top: 28px; padding-right: 24px; display: flex; flex-direction: column; align-items: flex-end; gap: 22px; }
.type_graph_item { display: flex; gap: 32px; align-items: center; justify-content: flex-end; }
.type_graph_item > p { font-size: 1.8rem; line-height: 1.4; letter-spacing: -0.01em; text-align: right; word-break: keep-all; }
.type_graph_item > picture { flex: 1; display: block; }
.type_graph_item img { display: block; max-width: 100%; }
.warning_box { margin-top: 16px; }
.warning_box p { color: #ed3030; font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; word-break: keep-all; }
.modal_bottom { margin-top: 40px; flex-shrink: 0; display: flex; align-items: center; justify-content: flex-end; gap: 8px; }
.modal_bottom > :deep(.btn_big) { width: 134px; text-align: center; font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; }
.modal_bottom > :deep(button.primary) { background-color:#15B874; }

@media (max-width: 768px) {
    :deep(.m_br) { display: block; }
    :deep(.p_br) { display: none; }
    .modal_content { padding: 0 20px; }
    .type_info_bar { padding: 16px 18px; font-size: 1.7rem; }
    .type_table_wrap { margin-top: 24px; }
    .type_table { min-width: 640px; }
    .type_table .col_item_main { width: 90px; }
    .type_table .col_item_sub { width: 160px; }
    .type_table thead th { padding: 18px 12px; font-size: 1.6rem; line-height: 1.24; }
    .type_table tbody th,
    .type_table tbody td { padding: 15px 14px; font-size: 1.6rem; line-height: 1.5; }
    .type_graph_wrap { margin-top: 40px; padding: 30px 20px; }
    .type_graph_wrap > strong { font-size: 2rem; }
    .type_graph_inner { margin-top: 24px; padding-right: 0; align-items: flex-start; gap: 20px; }
    .type_graph_item { flex-direction: column; align-items: flex-start; justify-content: flex-start; gap: 14px; }
    .type_graph_item > p { font-size: 1.6rem; text-align: left; }
}
</style>
